import { render } from "./AlertViewer.vue?vue&type=template&id=2e0e7bfc&ts=true"
import script from "./AlertViewer.vue?vue&type=script&lang=ts"
export * from "./AlertViewer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__